import Reveal from "./Reveal";
import { EXPERIENCE_POINTS } from "../data/menu";

const IMAGES = [
    {
        src: "/assets/saga-honey-fig.jpg",
        alt: "Honey Fig Meetha — coconut-dusted meetha paan with cherries, styled with honey and dried figs",
    },
    {
        src: "/assets/saga-classic-paan.jpg",
        alt: "Magai Meetha — soft Maghai-leaf meetha paan with cherries, served beside the traditional brass paan box and the Saga card",
    },
    {
        src: "/assets/menu-butterscotch-crunch.jpg",
        alt: "Crunchy Butterscotch — butterscotch-crumb meetha paan topped with a cherry, beside the Paan Saga box",
    },
];

const Experience = () => (
    <section id="experience" data-testid="experience-section" className="scroll-mt-24 py-24 lg:py-32">
        <div className="mx-auto max-w-7xl px-6 md:px-12">
            <div className="grid grid-cols-1 items-start gap-16 lg:grid-cols-2">
                <div>
                    <Reveal>
                        <p className="eyebrow">The Saga Experience</p>
                        <h2 className="mt-4 font-display text-4xl font-semibold tracking-tight text-saga-red sm:text-5xl">
                            More than a delicacy. An experience.
                        </h2>
                        <p className="mt-6 text-base leading-relaxed text-saga-ink/70 sm:text-lg">
                            We blend time-honoured craftsmanship with premium ingredients and modern presentation to create
                            unforgettable flavours — from classic favourites to innovative creations. Every paan is 100% tobacco-free,
                            handcrafted with the finest ingredients, aromatic flavours, and meticulous attention to detail.
                        </p>
                    </Reveal>
                    <div className="mt-12 grid grid-cols-1 gap-x-8 gap-y-10 sm:grid-cols-2">
                        {EXPERIENCE_POINTS.map((point, i) => (
                            <Reveal key={point.title} delay={0.1 + i * 0.08}>
                                <div className="border-t border-saga-red/20 pt-5">
                                    <h3 className="font-display text-xl font-semibold text-saga-ink">{point.title}</h3>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                </div>
                <div className="grid grid-cols-2 gap-4">
                    <Reveal className="col-span-2" delay={0.1}>
                        <div className="overflow-hidden rounded-2xl border border-saga-red/15">
                            <img
                                src={IMAGES[0].src}
                                alt={IMAGES[0].alt}
                                loading="lazy"
                                className="h-64 w-full object-cover transition-transform duration-700 hover:scale-105 sm:h-72"
                            />
                        </div>
                    </Reveal>
                    <Reveal delay={0.2}>
                        <div className="h-full overflow-hidden rounded-2xl border border-saga-red/15">
                            <img
                                src={IMAGES[1].src}
                                alt={IMAGES[1].alt}
                                loading="lazy"
                                className="h-52 w-full object-cover transition-transform duration-700 hover:scale-105 sm:h-60"
                            />
                        </div>
                    </Reveal>
                    <Reveal delay={0.3}>
                        <div className="h-full overflow-hidden rounded-2xl border border-saga-red/15">
                            <img
                                src={IMAGES[2].src}
                                alt={IMAGES[2].alt}
                                loading="lazy"
                                className="h-52 w-full object-cover transition-transform duration-700 hover:scale-105 sm:h-60"
                            />
                        </div>
                    </Reveal>
                </div>
            </div>
        </div>
    </section>
);

export default Experience;
